module.exports = __webpack_public_path__ + "e6c35742c291aad28b98e782086155df.svg";